import { defineComponent as _defineComponent } from 'vue'
import {
  CustomFieldsSchemaObject,
  CustomFieldsUiSchema,
  SchemaPropertyItems,
} from '@/models/types/custom-fields-schema'
import { computed } from 'vue'
import VsWrapper from '@/components/vision/VsWrapper.vue'
import VsTextInput from '@/components/vision/Inputs/VsTextInput.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'NumberField',
  props: {
    errorSchema: { default: null },
    formData: { default: null },
    params: null,
    rootSchema: null,
    schema: null,
    title: null,
    description: { default: null },
    uiSchema: null,
    disabled: { type: Boolean, default: false }
  },
  emits: ["change"],
  setup(__props: any, { emit }: { emit: ({
  (event: 'change', value: number): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { errorSchema: { errors?: string[] | null } | null, formData: number | null, params: never | null, rootSchema: SchemaPropertyItems, schema: CustomFieldsSchemaObject, title: string, description: string | null, uiSchema: CustomFieldsUiSchema, disabled: boolean }





const errorMessages = computed(() => props.errorSchema?.errors ?? [])

const handleInputChange = (event: string | undefined | null) => {
  if (!event || shouldNotEmitDataToParentComponent(event)) {
    // We want to type the number of type "-0.xyz..."
    // If this "if" statement doesn't exist, then when we type "-0", we have num = parseFloat("-0") = 0
    // Therefore, we lost the negative sign.
    // Similarly, when we type "-" only, event === "" (empty string), so parseFloat(event) will return NaN
    return
  }
  // On Firefox/Safari, if we type "123.", the variable 'event' is "".
  //    As a result, num = parseFloat("") = NaN
  // On Chrome, if we type "123.", the variable 'event' is "123".
  //    As a result, num = parseFloat("123.") = 123
  emit('change', parseFloat(event))
}

const shouldNotEmitDataToParentComponent = (num: string) => {
  if (num === '-0' || num === '-0.') {
    return true
  }

  // Regular expression to match "xyz.000...00" or "-xyz.000...00" or "xyz." or "-xyz."
  const pattern = /^-?[0-9]*\.0*$/
  return pattern.test(num)
}

return { __sfc: true,props, emit, errorMessages, handleInputChange, shouldNotEmitDataToParentComponent, VsWrapper, VsTextInput }
}

})